export const MercedesCancelIcon = (props) => (
    <svg width={props.size || 35} height={props.size || 35} viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg"{...props}>
        <path d="M25.7496 23.6875L19.5619 17.4998L25.7496 11.3121L23.6875 9.25L17.4998 15.4377L11.3121 9.25L9.25 11.3121L15.4377 17.4998L9.25 23.6875L11.3121 25.7496L17.4998 19.5619L23.6875 25.7496L25.7496 23.6875Z" fill="#414141" />
    </svg>
);



